<template>
  <AnimatedList class="w-full justify-center">
    <IdCardUtilisateur v-for="user of utilisateurStore.utilisateurs" :key="user.uuid" :utilisateur="user" />
  </AnimatedList>
</template>

<script setup>
import {UtilisateurStores} from "@/stores/UtilisateurStores";
import {NotificationStores} from "@/stores/NotificationStores";
import {enumeration} from "../../Enumeration";
import {router} from "@/routeur";
import {t} from "@/utils/Traduction";
import IdCardUtilisateur from "@/components/organismes/idCardUtilisateur.vue";
import AnimatedList from "@/components/molecules/AnimatedList.vue";

const utilisateurStore = UtilisateurStores();
const notificationStore = NotificationStores();

if(utilisateurStore.role !== enumeration.role.ADMIN) {
  utilisateurStore.logout(false);
  notificationStore.addNotification(t("youNeedToBeAdminToAccessThisPage"), 'error');
  router.push({ path: "/"});
}

utilisateurStore.loadUtilisateur();
</script>

<style scoped>

</style>